import { render, staticRenderFns } from "./CustomsDeclarationInInfo.vue?vue&type=template&id=77259084&scoped=true"
import script from "./CustomsDeclarationInInfo.vue?vue&type=script&lang=js"
export * from "./CustomsDeclarationInInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomsDeclarationInInfo.vue?vue&type=style&index=0&id=77259084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77259084",
  null
  
)

export default component.exports